export const state = {
  employees: [],
  departments: [],
  employeeDetail: {
    emp_id: "",
    dep_id: 0,
    org_cd: "",
    col_unit_cd: "",
    emp_level_id: "",
    display_name: "",
    mobile_no: "",
    email: "",
    created_at: "",
    updated_at: "",
    updated_by: "",
    stt: "",
    prov_id: null,
    dept: { dep_id: 0, dep_name: "" },
  },
  employeeMenu: [],
  emp_level: [],
};
